import Joi from 'joi';

export const DateRangeInput = Joi.object()
  .keys({
    from: Joi.string(),
    to: Joi.string(),
    includeNoDates: Joi.bool(),
  })
  .allow(null);

export const RangeInput = Joi.object()
  .keys({
    from: Joi.number(),
    to: Joi.number(),
  })
  .allow(null)
  .default(null);

export const MetricInput = Joi.object().keys({
  isPredicted: Joi.boolean(),
  platform: Joi.string(),
  mediaType: Joi.string(),
  style: Joi.string(),
  metricType: Joi.string(),
  iValue: Joi.number(),
  iaValue: Joi.array().items(Joi.number()),
  irValue: Joi.object().keys({
    from: Joi.number(),
    to: Joi.number(),
  }),
  sValue: Joi.string(),
});

export const inputSearchTypes = [
  { label: 'Strict', value: 'strict' },
  { label: 'Loose', value: 'loose' },
  { label: 'Bulk', value: 'bulk' },
  { label: 'Bulk by Id', value: 'bulkById' },
];

export const defaultInputSearchTypes = inputSearchTypes[0];

const metricMappings = {
  s: Joi.string(),
  ir: RangeInput,
  i: Joi.number(),
  ia: Joi.array().items(Joi.number()),
};

export const getMetricSchema = (filters) => {
  const metricSchema = {};

  Object.keys(filters).forEach((filter) => {
    filters[filter].forEach((f) => {
      if (filter === 'common') {
        metricSchema[`${f.type}-${f.field}`] = metricMappings[f.type];
      } else {
        metricSchema[`${filter}-${f.type}-${f.field}`] = metricMappings[f.type];
      }
    });
  });

  return metricSchema;
};
